<app-breadcrumb *ngIf="!support" [parentName]="'Wsparcie'" [name]="'Dodaj'"></app-breadcrumb>
<div class="support-add" fxLayout="column" fxLayoutGap="15px"  >

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button [class.spinner]="save" [disabled]="save"  (click)="sendForm()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button [class.spinner]="save" [disabled]="save" (click)="sendAndClose()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz i zamknij</span></button>
    <button [class.spinner]="save" [disabled]="save" (click)="cancel()"  mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Osoba zgłaszająca</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="100" >
            <app-dict-ofwcas-partners fxFlex="100" label="Szukaj" [required]="false" [control]="searchControl"></app-dict-ofwcas-partners>
          </div>


        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Osoba zgłaszająca</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="100" *ngIf="reportingPersonPartner">
            <app-dict-partners fxFlex="100" label="Partner" [required]="true" [control]="partnerControl"></app-dict-partners>
          </div>

          <div fxFlex="100" *ngIf=" reportingPersonOfwca ">
            <app-dict-ofwcas [control]="ofwcaControl" fxFlex="100" label="OFWCA" [required]="true"></app-dict-ofwcas>
          </div>

        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Formularz obsługi zgłoszenia</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-dict fxFlex = "50" dictType="client_type" label="Osoba zgłaszająca"
                    [control]="clientTypeControl" [required]="true" ></app-dict>
          <app-dict fxFlex = "50" dictType="type_of_report" label="Forma kontaktu"
                    [control]="typeOfReportControl"  [required]="true"></app-dict>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="ofwcaContracts.length>0 && reportingPersonOfwca && !reportingPersonPartner">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Umowy</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <table mat-table [dataSource]="ofwcaContracts">

            <!-- Position Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> Rodzaj</th>
              <td mat-cell *matCellDef="let element">
                {{element.type?.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="concludeDate">
              <th mat-header-cell *matHeaderCellDef> Data zawarcia</th>
              <td mat-cell *matCellDef="let element">
                {{element.concludeDate | date:'y-MM-dd'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef> Firma</th>
              <td mat-cell *matCellDef="let element">
                {{element.company?.name}}
              </td>
            </ng-container>


            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status</th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
              </td>
            </ng-container>

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef> Numer</th>
              <td mat-cell *matCellDef="let element">
               {{element.number}}
              </td>
            </ng-container>

            <ng-container matColumnDef="activeTo">
              <th mat-header-cell *matHeaderCellDef> Data zakończenia</th>
              <td mat-cell *matCellDef="let element">
                {{element.activeTo | date:'y-MM-dd'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="owner">
              <th mat-header-cell *matHeaderCellDef> Strona umowy</th>
              <td mat-cell *matCellDef="let element">
                {{element.owner?.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="party">
              <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.partner">
               {{element.partner?.shortName}}
                </ng-container>

                <ng-container *ngIf="element.ofwca">
            {{element.ofwca.fullName}}
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="assetsRegional">
              <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.partner">
                  {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
                </ng-container>

                <ng-container *ngIf="element.ofwca">
                  {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsContact"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsContact;"></tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="partnerContracts.length>0 && reportingPersonPartner">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Umowy</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <table mat-table [dataSource]="partnerContracts">

            <!-- Position Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> Rodzaj</th>
              <td mat-cell *matCellDef="let element">
                {{element.type?.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="concludeDate">
              <th mat-header-cell *matHeaderCellDef> Data zawarcia</th>
              <td mat-cell *matCellDef="let element">
                {{element.concludeDate | date:'y-MM-dd'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef> Firma</th>
              <td mat-cell *matCellDef="let element">
                {{element.company?.name}}
              </td>
            </ng-container>


            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status</th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
              </td>
            </ng-container>

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef> Numer</th>
              <td mat-cell *matCellDef="let element">
                {{element.number}}
              </td>
            </ng-container>

            <ng-container matColumnDef="activeTo">
              <th mat-header-cell *matHeaderCellDef> Data zakończenia</th>
              <td mat-cell *matCellDef="let element">
                {{element.activeTo | date:'y-MM-dd'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="owner">
              <th mat-header-cell *matHeaderCellDef> Strona umowy</th>
              <td mat-cell *matCellDef="let element">
                {{element.owner?.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="party">
              <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.partner">
                  {{element.partner?.shortName}}
                </ng-container>

                <ng-container *ngIf="element.ofwca">
                  {{element.ofwca.fullName}}
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="assetsRegional">
              <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.partner">
                  {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
                </ng-container>

                <ng-container *ngIf="element.ofwca">
                  {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsContact"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsContact;"></tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="partnerOfwca.length>0 && reportingPersonPartner">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Lista OFWCA partnera</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" >

          <table mat-table [dataSource]="partnerOfwca">

            <!-- Position Column -->
            <ng-container matColumnDef="box">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox
                  (change)="addOfwca(element)"
                  [checked]="isSelectOfwca(element)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="fullName">
              <th mat-header-cell *matHeaderCellDef> Imię i nazwisko</th>
              <td mat-cell *matCellDef="let element">
                  {{element.firstName}} {{element.lastName}}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status</th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
              </td>
            </ng-container>

            <ng-container matColumnDef="assetsRegional">
              <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
              <td mat-cell *matCellDef="let element">
                {{element.assetsRegional?.firstName}} {{element.assetsRegional?.lastName}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsOfwcaPartner"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsOfwcaPartner;"></tr>
          </table>

        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Rodzaj aktywności</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-dict fxFlex = "100" dictType="type_of_activity" label="Rodzaj aktywności"
                    [control]="typeOfActivityControl" [required]="true" ></app-dict>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="typeOfActivityOfwca && reportingPersonOfwca && ofwcaRegistrations">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Rejestracje OFWCA</h3>
        </div>
        <div fxLayout="row"  *ngIf="!ofwcaRegistrationActive">
          <mat-slide-toggle color="accent" [formControl]="ofwcaRegistrationActiveControl"> Rejestracje OFWCA</mat-slide-toggle>
        </div>

        <div>
          <form #filtersForm="ngForm" class="registration-list-filters">
            <ng-container>
              <app-dict-insurance-companies
                (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
                [multiple]="true" label="TU" class="registration-list-filter"
                [(ngModel)]="initialFilters.in$insuranceCompany"
                name="in$insuranceCompany"
              ></app-dict-insurance-companies>

              <app-dict
                [multiple]="true"
                label="Status" class="registration-list-filter"
                dictType="registration_status"
                [(ngModel)]="initialFilters.in$status" name="in$status"
              ></app-dict>

              <mat-form-field appearance="standard" class="registration-list-filter">
                <mat-label>Oświadczenia komplet</mat-label>
                <mat-select [(ngModel)]="initialFilters.statements" name="statements">
                  <mat-option [value]="null">Wszyscy</mat-option>
                  <mat-option [value]="1">Tak</mat-option>
                  <mat-option [value]="0">Nie</mat-option>
                </mat-select>
              </mat-form-field>

              <app-dict
                [multiple]="false"
                label="Firma" class="registration-list-filter"
                dictType="company"
                [(ngModel)]="initialFilters.company" name="company"
              ></app-dict>

            </ng-container>
          </form>

          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
            <div fxLayoutGap="15px">
              <button [disabled]="!(userPermissions | async).ofwca.read || generatingStatements"
                      [class.spinner]="generatingStatements" mat-stroked-button color="primary"
                      (click)="generateStatements()"><mat-icon>content_copy</mat-icon> <span> Wygeneruj oświadczenia</span></button>

              <button [disabled]="!(userPermissions | async).registration.create || generatingMultipleRegistration" mat-stroked-button color="primary"
                      (click)="addMultipleRegistration()"><mat-icon>playlist_add</mat-icon> Dodaj wiele rejestracji</button>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
              <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaRegistrationActive">

        <table mat-table [dataSource]="ofwcaRegistrations">

          <!-- Position Column -->
          <ng-container matColumnDef="insureCompany">
            <th mat-header-cell *matHeaderCellDef> TU</th>
            <td mat-cell *matCellDef="let element">
              {{element.insuranceCompany?.name}}
            </td>
          </ng-container>


          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef> Firma</th>
            <td mat-cell *matCellDef="let element">
              {{element.contract?.company?.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="statements">
            <th mat-header-cell *matHeaderCellDef> Oświadczenia komplet </th>
            <td mat-cell *matCellDef="let element" class="center-cell">
              <button *ngIf="element.statements" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
              <button *ngIf="!element.statements" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
            </td>
          </ng-container>


          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status</th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
            </td>
          </ng-container>

          <ng-container matColumnDef="partner">
            <th mat-header-cell *matHeaderCellDef> Partner </th>
            <td mat-cell *matCellDef="let element">
              {{element.contract?.partner?.shortName}}
            </td>
          </ng-container>

          <ng-container matColumnDef="login">
            <th mat-header-cell *matHeaderCellDef> Login </th>
            <td mat-cell *matCellDef="let element">
              <tr mat-cell *ngFor="let type of element.insuranceCompany.logins">
                {{registrationIdTypes[type].name}}: {{ registrationIdentifiers[element.uuid + type]?.value ? (registrationIdentifiers[element.uuid + type]?.value.split(', ').length > 0 ? registrationIdentifiers[element.uuid + type].value.split(', ')[registrationIdentifiers[element.uuid + type].value.split(', ').length -1] : 'BRAK') : 'BRAK'}}
              </tr>

             </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button *ngIf="[this.REGISTRATION_STATUS_EXAM_PASSED,this.REGISTRATION_STATUS_REGISTRATION_REQUEST].includes(element.status.key) && !element.statements"  [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="generateStatements(element)">Wygeneruj oświadczenia</button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsRegistrationsOfwca"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsRegistrationsOfwca;"></tr>
        </table>

        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="typeOfActivityOfwca && reportingPersonPartner">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Rejestracje</h3>
        </div>



          <app-all-registrations-list
            [excludeColumns]="['ofwca', 'partner', 'insuranceCompany', 'name', 'passedExam100p', 'statements', 'activeKrk', 'signedUpForAnExam','examPassed',
            'passedExam40p', 'sentToRegister', 'agreedToDeregister', 'deregistrationPack', 'missingExam','chronieLogin',
             'chronieDiscountCode',  'rauNumber', 'rauNumberError','sentToBlock', 'blocked', 'chronieAccess', 'actions']"
            [partnerId]="partnerControl.value"  [disableFilters]="true" [disableBreadcrumb]="true"
            [embeddedView]="false" [statusKeys]="ACTIVE_STATUSES"
          ></app-all-registrations-list>


      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100"  fxLayout.lt-lg="column" *ngIf="typeOfActivityGeneral">
    <div fxFlex = "50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxFlex="100">
        <div fxLayout="row">
          <h3>TU Majątek</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <table fxFlex="100"   >
            <tr >
              <td>
                <mat-checkbox class="example-margin"
                              (change)="setAllAssets($event.checked)">
                </mat-checkbox>

              </td>
              <td><h4> Zaznacz Wszystko </h4></td>
            </tr>
            <tr *ngFor="let headers of insuranceCompaniesAssets">
              <td>
                <mat-checkbox
                  (change)="addAssets(headers)"
                  [checked]="isSelect(headers.name)">
                </mat-checkbox>

              </td>
              <td>
                <img *ngIf="headers.imageLocation" class="insurance-company-logo"
                     src="/rest/crm/insuranceCompany/{{headers.id}}/image" alt="Zdjęcie" height="30"/>
              </td>
              <td> {{headers.name}}</td>

            </tr>
          </table>
        </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.supportForm.get('assetsQuantity').value > 0">
            <div fxFlex="100">
              <app-dict
                [label]="'Ryzyka majątkowe'" [dictType]="'support_property_risk'"
                 [control]="propertyRisk"
                [required]="true"
                [multiple]="true"
              ></app-dict>
            </div>
          </div>
      </mat-card>
    </div>
    <div fxFlex = "50" fxFlex.lt-md="100" fxLayoutGap="15px" >
      <mat-card fxFlex="100">
        <div fxLayout="row">
          <h3>TU Życie</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <table fxFlex="100"  >
            <tr >
              <td>
                <mat-checkbox class="example-margin"
                              (change)="setAllLife($event.checked)">
                </mat-checkbox>

              </td>

              <td><h4> Zaznacz Wszystko </h4></td>

            </tr>
            <tr *ngFor="let headers of insuranceCompaniesLife">
              <td>
                <mat-checkbox
                  (change)="addLife(headers)"
                  [checked]="isSelect(headers.name)">
                </mat-checkbox>

              </td>
              <td>
                <img *ngIf="headers.imageLocation" class="insurance-company-logo"
                     src="/rest/crm/insuranceCompany/{{headers.id}}/image" alt="Zdjęcie" height="30"/>
              </td>
              <td> {{headers.name}}</td>

            </tr>
          </table>
        </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.supportForm.get('lifeQuantity').value > 0">
            <div fxFlex="100">
              <app-dict
                [label]="'Ryzyka życiowe'" [dictType]="'support_life_risk'"
                 [control]="lifeRisk"
                [required]="true"
                [multiple]="true"
              ></app-dict>
            </div>
          </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.supportForm.get('lifeQuantity').value > 0">
          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Dane klienta</mat-label>
              <input appCapitalizeFirst matInput  [formControl]="customerDataControl"  [required]="true">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.supportForm.get('lifeQuantity').value > 0">
          <div fxFlex="100">
            <mat-slide-toggle color="accent" [formControl]="concludedPolicyControl"> Czy zawarta polisa</mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.supportForm.get('lifeQuantity').value > 0 && concludedPolicyControl.value">
          <div fxFlex="100">
            <mat-form-field  fxFlex="100">
              <mat-label>Numer polisy</mat-label>
              <input appCapitalizeFirst matInput [formControl]="policyNumberControl" [required]="true">
            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Notatka do rozmowy</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

            <mat-form-field fxFlex="100">
              <mat-label>Notatka</mat-label>
              <textarea [formControl]="noteControl"  matInput placeholder="Notatka" rows="10" autofocus ></textarea>
            </mat-form-field>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button [class.spinner]="save" [disabled]="save" (click)="sendForm()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button [class.spinner]="save" [disabled]="save" (click)="sendAndClose()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz i zamknij</span></button>
    <button [class.spinner]="save" [disabled]="save" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

